import __ from "../../../../services/translator";

export default function ButtonSave(props?: any)
{
    return (
        <span className="strong">
            <i className="fas fa-file-upload"></i>&nbsp;{ props.text? props.text : __('Save', 'save') }
        </span>
    )
}